var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-divider',{staticClass:"my-4 mx-auto",attrs:{"inset":_vm.inset}})
}
var staticRenderFns = []

export { render, staticRenderFns }